/* Scandinavian Edition — marks the page as scrolled so the header can show the slim logo.
   Fabric scrolls `.page-wrapper` on desktop (>= 990px) and the window on mobile, so we
   listen for scroll on both (capture phase) and read whichever has moved.
   Hysteresis (on after 80px, off below 10px) keeps the logo from flickering. */
(() => {
  const root = document.documentElement;
  const ON = 80;
  const OFF = 10;
  let ticking = false;

  const scrollTop = () => {
    const wrapper = document.querySelector('.page-wrapper');
    const wrapperTop = wrapper ? wrapper.scrollTop : 0;
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, wrapperTop);
  };

  const update = () => {
    ticking = false;
    const y = scrollTop();
    if (y > ON) root.setAttribute('data-se-scrolled', '');
    else if (y < OFF) root.removeAttribute('data-se-scrolled');
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  // `scroll` does not bubble, but it can be captured at the document level from any element.
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

/* A–Z switch in the mega menu: one letter group open at a time */
document.addEventListener('click', (event) => {
  const tab = event.target.closest?.('[data-se-az-tab]');
  if (!tab) return;
  const box = tab.closest('[data-se-az]');
  if (!box) return;
  const open = tab.getAttribute('aria-expanded') !== 'true';
  box.querySelectorAll('[data-se-az-tab]').forEach((t) => {
    const on = t === tab && open;
    t.setAttribute('aria-expanded', String(on));
    const list = document.getElementById(t.getAttribute('aria-controls'));
    if (list) list.hidden = !on;
  });
});
